
<div class="dateBody">
    <label class="dateLabels">START</label>
   <input  id="startDate" class="dateInput mb-2 mr-2" type="{{whichDatePicker == 'date' ?  'date': 'datetime-local'}}">
   <label class="dateLabels">END</label>
    <input id="endDate" class="mb-2 mr-2" type="{{whichDatePicker == 'date' ?  'date': 'datetime-local'}}">
    <button class="btn btn-primary btn-sm mr-2" [disabled]="clicked" (click)="getDates();">FILTER</button>
</div>
